import {
  GET_LIST_HOPDONGCHODUYET,
  GET_LIST_HOPDONGCHODUYET_SUCCESS,
  GET_LIST_HOPDONGCHODUYET_FAILURE,
  UPDATE_SEARCHTDATA_HOPDONGCHODUYET,
} from "./actionTypes";

export const getListHopDongChoDuyet = (dataSearch) => ({
  type: GET_LIST_HOPDONGCHODUYET,
  dataSearch,
});
export const getListHopDongChoDuyetSuccess = (data) => ({
  type: GET_LIST_HOPDONGCHODUYET_SUCCESS,
  payload: data,
});
export const getListHopDongChoDuyetFailure = (dataSearch) => ({
  type: GET_LIST_HOPDONGCHODUYET_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_HOPDONGCHODUYET,
  payload: data,
});
